module.exports = __webpack_public_path__ + "img/icon_v_o.33ca194e.svg";